import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "duplicate-order-content"
};
import FilterHeader from './components/FilterHeader.vue';
import DuplicateStatic from '@/views/orderManage/duplicateOrder/components/DuplicateStatic.vue';
import DuplicateTable from '@/views/orderManage/duplicateOrder/components/DuplicateTable.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'duplicateOrderIndex',
  setup(__props) {
    const tableRef = ref(null);
    const duplicateStaticRef = ref(null);
    const loading = ref(false);
    const filterSubmit = obj => {
      var _tableRef$value, _duplicateStaticRef$v;
      (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || _tableRef$value.searchData(obj);
      (_duplicateStaticRef$v = duplicateStaticRef.value) === null || _duplicateStaticRef$v === void 0 || _duplicateStaticRef$v.getOrderStatistics(obj);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(FilterHeader, {
        onFilterSubmit: filterSubmit,
        loading: loading.value
      }, null, 8, ["loading"]), _createVNode(DuplicateStatic, {
        ref_key: "duplicateStaticRef",
        ref: duplicateStaticRef
      }, null, 512), _createVNode(DuplicateTable, {
        ref_key: "tableRef",
        ref: tableRef
      }, null, 512)]);
    };
  }
});